import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ArrowUpIcon from "../icons/arrowUp.svg";

export default function ScrollToTopButton() {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.scrollY > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    return (
        <>
            {isVisible && (
                <button
                    onClick={scrollToTop}
                    aria-label={t("common.scrollToTop")}
                    className={`
            fixed bottom-[40px] lap:bottom-[80px] right-[40px] lap:right-[130px] xl:right-[40px] z-50 flex items-center justify-center bg-background-600 shadow-md transition-colors duration-300 hover:bg-background-400 rounded-full p-[10px] w-[50px] h-[50px] md:w-[70px] md:h-[70px]`}
                >
                    <img
                        src={ArrowUpIcon}
                        alt={t("common.scrollToTop")}
                        className="w-[16px] h-[30px] md:w-[23px] md:h-[40px] object-contain"
                    />
                </button>
            )}
        </>
    );
}
